<template>
  <div class="container">
    <h1 class="text-center">vue-circle-slider | 基于Vue.js的圆形滑块组件</h1>
    <div class="htmleaf-links">
        <a class="htmleaf-icon icon-htmleaf-home-outline" href="http://www.htmleaf.com/" title="jQuery之家" target="_blank">
            <img width="120px" style="width:120px;" src="./assets/img/logo.png" alt="jQuery之家">
        </a>
    </div>
    <div class="row">
        <h4>Default</h4>
        <p>Usage without any props</p>
        <div class="flex">
            <div class="code">
                <pre>
&lt;circle-slider v-model="sliderValue1"&gt;&lt;/circle-slider&gt;
                </pre>
            </div>
            <div class="desc">
                <circle-slider v-model="sliderValue1"></circle-slider>
                <div class="center">{{ sliderValue1 }}</div>
            </div>
        </div>
    </div>

    <div class="row">
        <h4>Custom dimension</h4>
        <p>Custom min/max values and step size</p>
        <div class="flex">
            <div class="code">
                <pre>
&lt;circle-slider
    v-model="sliderValue2"
    :min="0"
    :max="10000"
    :step-size="100"
&gt;&lt;/circle-slider&gt;
                </pre>
            </div>
            <div class="desc">
                <circle-slider
                    v-model="sliderValue2"
                    :min="0"
                    :max="10000"
                    :step-size="100"
                ></circle-slider>
                <div class="center">{{ sliderValue2 }}</div>
            </div>
        </div>
    </div>

    <div class="row">
        <h4>Custom side</h4>
        <p>Exact size of svg square side (in px)</p>
        <div class="flex">
            <div class="code">
                <pre>
&lt;circle-slider :side="150" v-model="sliderValue3"&gt;&lt;/circle-slider&gt;
&lt;circle-slider :side="50" v-model="sliderValue3"&gt;&lt;/circle-slider&gt;

&lt;div&gt;{{ sliderValue3 }}&lt;/div&gt;
                </pre>
            </div>
            <div class="desc">
                <circle-slider :side="150" v-model="sliderValue3"></circle-slider>
                <circle-slider :side="50" v-model="sliderValue3"></circle-slider>

                <div>{{ sliderValue3 }}</div>
            </div>
        </div>
    </div>

    <div class="row">
        <h4>Exact sizes</h4>
        <p>Custom circumference and progress curve width, custom knob radius</p>
        <div class="flex">
            <div class="code">
                <pre>
&lt;circle-slider
    v-model="sliderValue4"
    :circle-width="8"
    :progress-width="12"
    :knob-radius="10"
&gt;&lt;/circle-slider&gt;

&lt;circle-slider
    v-model="sliderValue4"
    :circle-width="10"
    :progress-width="5"
    :knob-radius="10"
&gt;&lt;/circle-slider&gt;

&lt;circle-slider
    v-model="sliderValue4"
    :circle-width="12"
    :progress-width="3"
    :knob-radius="4"
&gt;&lt;/circle-slider&gt;

&lt;div&gt;{{ sliderValue4 }}&lt;/div&gt;
                </pre>
            </div>
            <div class="desc">
                <circle-slider
                    v-model="sliderValue4"
                    :circle-width="8"
                    :progress-width="12"
                    :knob-radius="10"
                ></circle-slider>

                <circle-slider
                    v-model="sliderValue4"
                    :circle-width="10"
                    :progress-width="5"
                    :knob-radius="10"
                ></circle-slider>

                <circle-slider
                    v-model="sliderValue4"
                    :circle-width="12"
                    :progress-width="3"
                    :knob-radius="4"
                ></circle-slider>

                <div>{{ sliderValue4 }}</div>
            </div>
        </div>
    </div>

    <div class="row">
        <h4>Relative sizes</h4>
        <p>Custom relative circumference and progress curve width, custom relative knob radius.</p>
        <div class="flex">
            <div class="code">
                <pre>
&lt;circle-slider
    v-model="sliderValue5"
    :circle-width-rel="30"
    :progress-width-rel="15"
    :knob-radius-rel="8"
&gt;&lt;/circle-slider&gt;

&lt;div&gt;{{ sliderValue5 }}&lt;/div&gt;
                </pre>
            </div>
            <div class="desc">
                <circle-slider
                    v-model="sliderValue5"
                    :circle-width-rel="30"
                    :progress-width-rel="15"
                    :knob-radius-rel="8"
                ></circle-slider>

                <div>{{ sliderValue5 }}</div>
            </div>
        </div>
    </div>

    <div class="row">
        <h4>Colors</h4>
        <p>自定义圆环、进度条和knob的颜色</p>
        <div class="flex">
            <div class="code">
                <pre>
&lt;circle-slider
    v-model="sliderValue5"
    circle-color="#edeff0"
    progress-color="#cecece"
    knob-color="#a0a0ff"
&gt;&lt;/circle-slider&gt;

&lt;circle-slider
    v-model="sliderValue5"
    circle-color="#f00"
    progress-color="#0a0"
    knob-color="#0c0"
&gt;&lt;/circle-slider&gt;

&lt;circle-slider
    v-model="sliderValue5"
    circle-color="#cecece"
    progress-color="#00f"
    knob-color="#5555ff"
&gt;&lt;/circle-slider&gt;

&lt;div&gt;{{ sliderValue5 }}&lt;/div&gt;
                </pre>
            </div>
            <div class="desc">
                <circle-slider
                    v-model="sliderValue5"
                    circle-color="#edeff0"
                    progress-color="#cecece"
                    knob-color="#a0a0ff"
                ></circle-slider>

                <circle-slider
                    v-model="sliderValue5"
                    circle-color="#f00"
                    progress-color="#0a0"
                    knob-color="#0c0"
                ></circle-slider>

                <circle-slider
                    v-model="sliderValue5"
                    circle-color="#cecece"
                    progress-color="#00f"
                    knob-color="#5555ff"
                ></circle-slider>

                <div>{{ sliderValue5 }}</div>
            </div>
        </div>
    </div>

    <div class="row">
        <h4>双向绑定</h4>
        <p>在输入框中输入进度值改变滑块，或拖动滑块改变输入框的值</p>
        <div class="flex">
            <div class="code">
                <pre>
&lt;circle-slider
    v-model="sliderValue7"
    @touchmove="$refs.input.blur()"
&gt;&lt;/circle-slider&gt;

&lt;input ref="input" type="number" v-model.number="sliderValue7" /&gt;
                </pre>
            </div>
            <div class="desc">
                <circle-slider
                    v-model="sliderValue7"
                    @touchmove="$refs.input.blur()"
                ></circle-slider>
                <!-- @touchmove="$refs.input.blur()" - hide keyboard on touchmove at mobile devices -->

                <input ref="input" type="number" v-model.number="sliderValue7" />
            </div>
        </div>
    </div>
    <div class="related">
        <h3>如果你喜欢这个插件，那么你可能也喜欢:</h3>
        <a href="http://www.htmleaf.com/jQuery/Form/201810105360.html">
            <img src="./assets/img/1.jpg" width="300"/>
            <h3>jQuery多功能滑块插件r-slider.js</h3>
        </a>
        <a href="http://www.htmleaf.com/jQuery/Form/201906115686.html">
            <img src="./assets/img/2.jpg" width="300"/>
            <h3>超炫酷UI效果的jQuery滑块插件</h3>
        </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  },
  data() {
    return {
        sliderValue1: 30,
        sliderValue2: 2000,
        sliderValue3: 75,
        sliderValue4: 50,
        sliderValue5: 50,
        sliderValue6: 25,
        sliderValue7: 10
    }
  }
}
</script>

<style>
.flex {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 25px;
    margin-bottom: 30px;
    border-bottom: 1px solid #f2f2f2;
}
.code{
    width: 50%;
    padding: 0 30px;
    background-color: #f2f2f2;
    border: 1px solid #ccc;
}
.desc {
    width: 50%;
    text-align: center;
}
.center {
    text-align: center;
}
</style>
